<template>
    <div>
        <div class="border border-dark-primary bg-neutral-50 shadow-sm p-2">
            <div class="flex flex-col h-[80vh] w-full">
                <div class="flex flex-col text-base w-full my-2">
                    <div class="w-full border-b border-b-gray-500 flex justify-between text-gray-500 tracking-widest">
                        <div>
                            Company
                        </div>
                        <div v-if="isEditable" class="flex space-x-2 pb-1">
                            <base-button-negative @click="toggleEditable">✘</base-button-negative>
                            <base-button-affirmative @click="acceptChanges">✔</base-button-affirmative>
                        </div>
                        <div v-else class="flex justify-between">
                            <div title="Reset company" class="hover:cursor-pointer hover:bg-gray-300 rounded-full p-0.5 mx-1" @click="resetCompany" >
                                <UndoArrowSVG/>
                            </div>
                            <div title="Edit" class="hover:cursor-pointer hover:bg-gray-300 rounded-full p-0.5 mx-1" @click="toggleEditable">
                                <EditSVG/>
                            </div>
                        </div>
                    </div>
                    <div class="pl-2">
                        <a :href="googleUrlLink" target="_blank">{{ companyToVet.company_name }}</a>
                    </div>
                </div>
                <div class="flex flex-col text-base w-full my-2">
                    <CompanyToVetUrl @update-url="updateUrl" :company="companyToVet" :is-editable="isEditable" />
                </div>
                <div class="flex flex-col text-base w-full my-2">
                    <CompanyToVetAddress @update-address="updateAddress" :company="companyToVet" :is-editable="isEditable" />
                </div>
                <div class="flex flex-col text-base w-full my-2">
                    <CompanyToVetCity @update-city="updateCity" :company="companyToVet" :is-editable="isEditable" />
                </div>
                <div class="flex flex-col text-base w-full my-2">
                    <CompanyToVetState @update-state="updateState" :company="companyToVet" :is-editable="isEditable" />
                </div>
                <div class="flex flex-col text-base w-full my-2">
                    <CompanyToVetCountry @update-country="updateCountry" :company="companyToVet" :is-editable="isEditable" />
                </div>
                <div class="flex items-center w-full h-1/4 border-t border-t-gray-500 justify-center">
                    <button class="m-2 rounded-md h-1/2 w-1/2  p-1 bg-accent-primary text-white border border-accent-primary  hover:shadow-md active:text-white active:bg-accent-secondary focus:text-white focus:bg-accent-secondary text-base hover:cursor-pointer" @click="markVetted">Mark Vetted</button>
                    <button class="m-2 rounded-md h-1/2 w-1/2 p-1 hover:shadow-md bg-dark-secondary text-white border border-dark-secondary active:bg-dark-primary active:text-white focus:bg-dark-primary focus:text-white text-base hover:cursor-pointer" @click="markNoUrl">Mark No URL</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, reactive, computed, watch } from 'vue';
import CompanyToVetAddress from './CompanyToVetAddress.vue';
import CompanyToVetUrl from './CompanyToVetUrl.vue';
import CompanyToVetCity from './CompanyToVetCity.vue';
import CompanyToVetState from './CompanyToVetState.vue';
import CompanyToVetCountry from './CompanyToVetCountry.vue';
import EditSVG from '../svg-components/EditSVG.vue';
import UndoArrowSVG from '../svg-components/UndoArrowSVG.vue';

const props = defineProps([
    'companyToVet'
])

const isEditable = ref(false)

function toggleEditable(){
    isEditable.value = !isEditable.value
}

const companyData = reactive({
    website_url: props.companyToVet ? props.companyToVet.website_url : null,
    address: props.companyToVet ? props.companyToVet.address : null,
    city: props.companyToVet ? props.companyToVet.city : null,
    state: props.companyToVet ? props.companyToVet.state : null,
    country: props.companyToVet ? props.companyToVet.country : null
})

watch(() => props.companyToVet, () => {
    isEditable.value = false
    companyData.website_url = props.companyToVet ? props.companyToVet.website_url : null,
    companyData.address = props.companyToVet ? props.companyToVet.address : null,
    companyData.city = props.companyToVet ? props.companyToVet.city : null,
    companyData.state = props.companyToVet ? props.companyToVet.state : null,
    companyData.country = props.companyToVet ? props.companyToVet.country : null
}, {deep: true})

const emit = defineEmits([
    'reset-company',
    'update-company',
    'mark-vetted',
    'mark-no-url'
])

function updateUrl(websiteUrl){
    companyData.website_url = websiteUrl
}

function updateAddress(address){
    companyData.address = address
}

function updateCity(city){
    companyData.city = city
}

function updateState(state){
    companyData.state = state
}

function updateCountry(country){
    companyData.country = country
}

function acceptChanges(){
    if(!companyData.website_url){
        companyData.website_url = 'mark_no_url'
    }
    emit('update-company', props.companyToVet.id, companyData)
    toggleEditable()
}

function resetCompany(){
    emit('reset-company', props.companyToVet.id)
}

function markVetted(){
    emit('mark-vetted', props.companyToVet.id)
}

function markNoUrl(){
    emit('mark-no-url', props.companyToVet.id)
}

const googleUrlLink = computed(() => {
    if(props.companyToVet){
        return `https://www.google.com/search?q=${props.companyToVet.company_name.replace(' ', '+').replace('&', '%26')}+${props.companyToVet.city ? props.companyToVet.city.replace(' ', '+') : ''}+${props.companyToVet.state ? props.companyToVet.state.replace(' ', '+') : ''}+${props.companyToVet.country ? props.companyToVet.country.replace(' ', '+') : ''}`
    } else {
        return null
    }
})

</script>